/**
 * Feature flags based on deployment stage.
 *
 * prod is replaced at build time by KatalWebpackPlugin with the
 * CloudFormation-injected stage value (beta, gamma, prod).
 * During local development, the default is 'beta'.
 */

const STAGE = "prod".toLowerCase();

/**
 * Bilingual (EN + ES) toggle: shown in beta and gamma; hidden in prod.
 */
export const isBilingualEnabled = (): boolean => {
  return STAGE !== 'prod';
};

/**
 * Returns the current deployment stage.
 */
export const getStage = (): string => {
  return STAGE;
};
